<template>
  <div class="pl-3 pr-3">
    <v-container class="pl-10 pr-10">
      <p class="display-1 mt-7">분실 상품 이력 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">정품 인증을 한 고객이 분실한 경우 해당 상품의 이력 관리가 가능합니다.</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        분실 상태의 상품을 누군가가 인증 시도를 할 경우 원래의 정품 인증자에게
        알림을 설정할 수 있습니다.
      </p>

      <LostRecordSearch ref="lostSearchComponent"></LostRecordSearch>
      <LostRecordResultList ref="lostListComponent"></LostRecordResultList>
    </v-container>
  </div>
</template>

<script>
import LostRecordSearch from "@/components/authservice/lostRecord/LostRecordSearch.vue";
import LostRecordResultList from "@/components/authservice/lostRecord/LostRecordResultList.vue";

export default {
  components: {
    LostRecordSearch,
    LostRecordResultList
  }
};
</script>
